var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"v-table-cell",class:[_vm.data.staticClass, _vm.data.class],style:([_vm.data.staticStyle, _vm.data.style])},'div',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }